import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function SignedOut() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-[400px] space-y-8">
        {/* Heading */}
        <h1 className="text-2xl font-bold text-foreground text-center">
          You've been signed out
        </h1>

        {/* Body */}
        <p className="text-xs text-muted-foreground text-center">
          For your security, we signed you out after a period of inactivity. Your progress has been saved — simply sign back in to continue.
        </p>

        {/* CTA */}
        <Button
          onClick={() => navigate('/login', { replace: true })}
          className="w-full"
        >
          Sign Back In
        </Button>
      </div>
    </div>
  );
}
